import React from 'react';
import { BannerTypes } from '@gin-betting/banners';
import LazyImage from '@gin-betting/components/lazy-image';

import './bannersImage.scss';

interface OwnProps {
    banner: BannerTypes.BannerInfo;
}

type Props = OwnProps;

const BannerImage: React.FC<Props> = ({ banner }) => {
    const {
        imageHref,
        imageSrc: bannerSrc,
        title,
        buttonHref,
        buttonText,
    } = banner;

    if (!bannerSrc) return null;

    return (
        <div styleName="container" className="__app-Banners-container">
            <div styleName="list">
                <LazyImage url={bannerSrc} isFullSize={true}>
                    {({ url, ref }) => {
                        return (
                            <a
                                ref={ref}
                                href={imageHref}
                                styleName="item"
                                className="__app-BannerImage-item"
                                title={title}
                            >
                                {url && (
                                    <img
                                        styleName="img"
                                        className="__app-BannerImage-img"
                                        src={url}
                                        alt={title}
                                    />
                                )}

                                {!!buttonText && url && (
                                    <a
                                        styleName="button"
                                        href={buttonHref || imageHref}
                                    >
                                        {buttonText}
                                    </a>
                                )}
                            </a>
                        );
                    }}
                </LazyImage>
            </div>
        </div>
    );
};

export default React.memo(BannerImage);
